<!--suppress CssUnusedSymbol -->
<template>
	<nav class="top-0 absolute z-50 w-full flex flex-wrap items-center justify-between px-2 py-3 navbar-expand-lg">
		<div class="container px-4 mx-auto flex flex-wrap items-center justify-between">
			<div class="w-full relative flex justify-between md:w-auto md:static md:block md:justify-start">
				<router-link :to="this.getRouteUrl('')">
					<i id="lang-dropdown-2" class="fas fa-home text-white mr-4 fa-lg"></i>
				</router-link>
				<button class="cursor-pointer text-xl leading-none py-1 border border-solid border-transparent rounded bg-transparent block md:hidden outline-none focus:outline-none"
						type="button"
						v-on:click="toggleNavbar()">
					<span id="nav-icon1" class="block">
						<span></span>
						<span></span>
						<span></span>
					</span>
				</button>
			</div>
			<div id="nav-menu-wrapper" class="md:flex flex-grow items-center custom-background md:bg-transparent md:shadow-none"
			     v-bind:class="{ 'nav-menu-closed': !showMenu, 'nav-menu-open': showMenu }">
				<ul class="flex flex-col md:flex-row list-none mr-auto">
					<li class="flex items-center"></li>
				</ul>
				<ul id="nav-menu" class="flex flex-col md:flex-row list-none md:ml-auto">
					<li class="flex items-center justify-end">
						<router-link :to="this.getRouteUrl('about')"
						             class="text-white md:hover:text-gray-300 px-2 md:px-3 py-4 md:py-2 flex items-center text-sm uppercase font-bold">
							{{ getText('about-nav') }}
						</router-link>
						<router-link :to="this.getRouteUrl('projects')"
						             class="text-white md:hover:text-gray-300 px-2 md:px-3 py-4 md:py-2 flex items-center text-sm uppercase font-bold">
							{{ getText('projects') }}
						</router-link>
						<router-link :to="this.getRouteUrl('contacts')"
						             class="text-white md:hover:text-gray-300 px-2 md:px-3 py-4 md:py-2 flex items-center text-sm uppercase font-bold">
							{{ getText('contacts') }}
						</router-link>
						<language-selector v-if="showLangDropdown"></language-selector>
					</li>
				</ul>
			</div>
		</div>
	</nav>
</template>
<script>
	import LanguageSelector from './LanguageSelector';
	import {mapGetters} from 'vuex'

	export default {
		data() {
			return {
				showMenu: false,
				// Hidden until all other texts are ready
				showLangDropdown: true,
			};
		},
		components: {
			LanguageSelector: LanguageSelector,
		},
		methods: {
			toggleNavbar: function () {
				this.showMenu = !this.showMenu;
				document.getElementById('nav-icon1').classList.toggle('open');
			},
		},
		computed: {
			...mapGetters(['getText', 'getRouteUrl'])
		},
		watch: {
			// Listen to a route change and close the menu
			$route() {
				this.showMenu = false;
				document.getElementById('nav-icon1').classList.remove('open');
			}
		}
	};
</script>

<style lang="sass">
	#nav-menu
		.router-link-exact-active
			text-decoration: underline

		.custom-background
			background-color: #3737373d
			backdrop-filter: grayscale(0.5) opacity(0.8)
</style>

<style>
	#nav-icon1 {
		width: 20px;
		height: 20px;
		position: relative;
		-webkit-transform: rotate(0deg);
		-moz-transform: rotate(0deg);
		-o-transform: rotate(0deg);
		transform: rotate(0deg);
		-webkit-transition: .5s ease-in-out;
		-moz-transition: .5s ease-in-out;
		-o-transition: .5s ease-in-out;
		transition: .5s ease-in-out;
		cursor: pointer;
	}

	#nav-icon1 span, #nav-icon3 span, #nav-icon4 span {
		display: block;
		position: absolute;
		height: 3px;
		width: 100%;
		background: white;
		border-radius: 9px;
		opacity: 1;
		left: 0;
		-webkit-transform: rotate(0deg);
		-moz-transform: rotate(0deg);
		-o-transform: rotate(0deg);
		transform: rotate(0deg);
		-webkit-transition: .25s ease-in-out;
		-moz-transition: .25s ease-in-out;
		-o-transition: .25s ease-in-out;
		transition: .25s ease-in-out;
	}

	#nav-icon1 span:nth-child(1) {
		top: 0;
	}

	#nav-icon1 span:nth-child(2) {
		top: 6px;
	}

	#nav-icon1 span:nth-child(3) {
		top: 12px;
	}

	#nav-icon1.open span:nth-child(1) {
		top: 4px;
		-webkit-transform: rotate(135deg);
		-moz-transform: rotate(135deg);
		-o-transform: rotate(135deg);
		transform: rotate(135deg);
	}

	#nav-icon1.open span:nth-child(2) {
		opacity: 0;
		left: -60px;
	}

	#nav-icon1.open span:nth-child(3) {
		top: 4px;
		-webkit-transform: rotate(-135deg);
		-moz-transform: rotate(-135deg);
		-o-transform: rotate(-135deg);
		transform: rotate(-135deg);
	}

	@media (max-width: 767px) {
		.nav-menu-open {
			height: 60px;
			overflow: hidden;
			transition: height 600ms ease-out;
		}

		.nav-menu-open-lang {
			height: 200px;
		}

		.nav-menu-closed {
			height: 0;
			overflow: hidden;
			transition: height 600ms ease-out;
		}
	}
</style>
